import React, { useState, useEffect } from 'react';
import SearchIcon from '@material-ui/icons/Search';

import SideBar from '~/components/layout/Sidebar';
import funcionariosIcon from '~/assets/images/funcionarios.svg';
import Header from '~/components/layout/Header';
import EmployeeItem from '~/components/pages/EmployeeList/Item';
import OpenChatBot from '~/components/layout/Chatbot';

import back from '~/assets/images/arrow.svg';
import {
  Container,
  HeaderContainer,
  Content,
  TitleContainer,
  FielterContainer,
  FielterButton,
  EmployeeListContainer,
  HeaderMobile,
  HeaderIcon,
  HeaderText,
  Wrapper,
  NextPage,
  NextPageContainer,
  TextNoResults,
  CloseIcon,
  CloseIconContainer,
} from './styles';

import api from '~/services/api';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import Loading from '~/components/layout/Loading';

export default function EmployeeList() {
  const history = useHistory();
  const [search, setSearch] = useState('');
  const [activeFilter, setActiveFilter] = useState(true);
  const [storeIdList, setStoreIdList] = useState([]);
  const [employeesActiveList, setEmployeesActiveList] = useState([]);
  const [employeesInactiveList, setEmployeesInactiveList] = useState([]);
  const [loadingNext, setLoadingNext] = useState(true);
  const [hasMorePage, setHasMorePage] = useState(true);
  const [hasMorePageInactive, setHasMorePageInactive] = useState(true);
  const [countActiveUsers, setCountActiveUsers] = useState(0);
  const [countInactiveUsers, setCountInactiveUsers] = useState(0);
  const [loadingAPI, setLoadingAPI] = useState(true);
  const employeesList_offset = 10;

  const storesReducer = useSelector(state => state.economicGroupReducer.stores);

  const getStoresId = () => {
    if (storeIdList.length < 1) {
      let listStores = [];

      storesReducer.map(store => {
        listStores = [...listStores, store.storeId];
        return null;
      });

      let storesToString;

      if (listStores) {
        storesToString = listStores.toString()
      }

      setStoreIdList(storesToString);
      return storesToString;
    } else {
      return storeIdList;
    }
  };

  const getListOfEmployeesActive = async () => {
    setLoadingNext(true);

    const listStores = getStoresId();

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    await api
      .get(
        `residential/store/v1/users?store-id-access=${listStores}&_expand=CONTACT&_limit=1000&_offset=0&is-active=true`,
        parameters,
      )
      .then(res => {
        let employees = res.data;
        if (employees.length > 0) {
          employees = employees.filter(function (a) {
            return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
          }, Object.create(null));

          employees = employees.filter(newItem => {
            let filteredList = employeesActiveList.filter(item => {
              return item.userId === newItem.userId;
            });

            if (filteredList.length > 0) {
              return false;
            } else {
              return newItem;
            }
          });

          let newList = [...employeesActiveList, ...employees];

          newList = newList.map(item => {
            item.searchStatus = true;
            item.onList = false;
            return item;
          });
          newList = handleOnList(newList, true);
          setEmployeesActiveList(newList);
          setLoadingAPI(false);
        } else {
          setLoadingAPI(false);
          setHasMorePage(false);
        }
        setLoadingNext(false);
      })
      .catch(err => {
        toast.error(err.response.data.message);
      });
  };

  const getListOfEmployeesInactive = async () => {
    setLoadingNext(true);

    const listStores = getStoresId();

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    await api
      .get(
        `residential/store/v1/users?store-id-access=${listStores}&_expand=CONTACT&_limit=1000&_offset=0&is-active=false`,
        parameters,
      )
      .then(res => {
        let employees = res.data;
        if (employees.length > 0) {
          employees = employees.filter(function (a) {
            return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
          }, Object.create(null));

          employees = employees.filter(newItem => {
            let filteredList = employeesActiveList.filter(item => {
              return item.userId === newItem.userId;
            });

            if (filteredList.length > 0) {
              return false;
            } else {
              return newItem;
            }
          });

          let newList = [...employeesActiveList, ...employees];

          newList = newList.map(item => {
            item.searchStatus = true;
            item.onList = false;
            return item;
          });
          newList = handleOnList(newList, false);
          setEmployeesInactiveList(newList);
          setLoadingAPI(false);
        } else {
          setLoadingAPI(false);
          setHasMorePageInactive(false);
        }
        setLoadingNext(false);
      })
      .catch(err => {
        toast.error(err.response.data.message);
      });
  };

  useEffect(() => {
    getListOfEmployeesActive();
    getListOfEmployeesInactive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnList = (list, paramActiveFilter, noCount) => {
    let count = 0;
    let total = 0;
    let newList = list.map(item => {
      item.onList = false;
      if (item.active === paramActiveFilter) {
        if (paramActiveFilter) {
          if (count < countActiveUsers + employeesList_offset) {
            item.onList = true;
            count++;
          }
        } else {
          if (count < countInactiveUsers + employeesList_offset) {
            item.onList = true;
            count++;
          }
        }
        total++;
      }
      return item;
    });

    if(noCount !== false) {
      if (paramActiveFilter) {
        setCountActiveUsers(count);
        if (count === total) {
          setHasMorePage(false);
        }
      } else {
        setCountInactiveUsers(count);
        if (count === total) {
          setHasMorePageInactive(false);
        }
      }
    }

    return newList;
  };

  const nextPage = paramActiveFilter => {
    if(paramActiveFilter) {
      setEmployeesActiveList(
        handleOnList(employeesActiveList, paramActiveFilter),
      );
    }
    else {
      setEmployeesInactiveList(
        handleOnList(employeesInactiveList, paramActiveFilter),
      );
    }
  };

  useEffect(() => {
    let newEmployeesActiveList = employeesActiveList.map(item => {
      item.searchStatus = false;
      return item;
    });

    let newEmployeesInactiveList = employeesInactiveList.map(item => {
      item.searchStatus = false;
      return item;
    });

    if (!search) {
      setEmployeesActiveList(newEmployeesActiveList);
      setEmployeesInactiveList(newEmployeesInactiveList);
    } else {
      let newEmployeesList;

      if (activeFilter) {
        newEmployeesList = newEmployeesActiveList;
      } else {
        newEmployeesList = newEmployeesInactiveList;
      }

      newEmployeesList = newEmployeesList.map(item => {
        item.searchStatus = false;
        if (!search) {
          item.searchStatus = true;
        } else {
          if (item.contacts.length > 1) {
            item.contacts.map(itemContacts => {
              if (itemContacts) {
                if (
                  itemContacts.name &&
                  itemContacts.name
                    .toLowerCase()
                    .indexOf(search.toLowerCase()) >= 0
                ) {
                  item.searchStatus = true;
                } else if (itemContacts.contactType === 'EMAIL') {
                  if (
                    itemContacts.contact &&
                    itemContacts.contact
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) >= 0
                  ) {
                    item.searchStatus = true;
                  }
                }
              }
              return null;
            });
          }
        }
        return item;
      });

      if (activeFilter) {
        setEmployeesActiveList(newEmployeesList);
        setEmployeesInactiveList(newEmployeesInactiveList);
      } else {
        setEmployeesActiveList(newEmployeesActiveList);
        setEmployeesInactiveList(newEmployeesList);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, activeFilter]);

  return (
    <Container>
      {!localStorage.getItem('ownerid') ? (
        <SideBar menuSelected="Início" disabledOnMobile>
          <HeaderContainer>
            <Header />
          </HeaderContainer>

          <Content>
            <HeaderMobile>
              <HeaderIcon className="mdi mdi-store mr-2" />
              <HeaderText>{localStorage.getItem('storeName')}</HeaderText>
            </HeaderMobile>
            <Wrapper>
              <CloseIconContainer>
                <CloseIcon>
                  <img
                    src={back}
                    alt="Ícone para voltar"
                    onClick={() => history.push('/portal')}
                  />
                </CloseIcon>
              </CloseIconContainer>
              <TitleContainer>
                <div className="title">
                  <img src={funcionariosIcon} alt="Ícone ajuda cinza" />
                  <h3>Usuários cadastrados</h3>
                </div>
                <div className="container-input">
                  <input
                    type="text"
                    placeholder="Pesquisar pelo nome ou e-mail"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                  <SearchIcon
                    style={{
                      position: 'relative',
                      left: '90%',
                      margin: '-4rem 0 0 0',
                      color: '#000FFF',
                    }}
                  />
                </div>
              </TitleContainer>
              {loadingAPI ? (
                <Loading />
              ) : (
                <>
                  <FielterContainer>
                    <FielterButton
                      active={activeFilter && true}
                      onClick={() => setActiveFilter(true)}
                    >
                      Usuários ativos
                    </FielterButton>
                    <FielterButton
                      active={!activeFilter && true}
                      onClick={() => setActiveFilter(false)}
                    >
                      Usuários inativos
                    </FielterButton>
                  </FielterContainer>
                  <EmployeeListContainer>
                    {activeFilter
                      ? employeesActiveList
                          .filter(item => {
                            return search ? item.searchStatus === true : item.onList && item;
                          })
                          .map(item => {
                            return (
                              <EmployeeItem
                                key={item.userId}
                                employeeData={item}
                                employeeName={item.contacts[0].name}
                                registerDate={item.createdDate}
                                status={item.active}
                              />
                            );
                          })
                      : employeesInactiveList
                          .filter(item => {
                            return search ? item.searchStatus === true : item.onList && item;
                          })
                          .map(item => {
                            return (
                              <EmployeeItem
                                key={item.userId}
                                employeeData={item}
                                employeeName={item.contacts[0].name}
                                registerDate={item.createdDate}
                                status={item.active}
                              />
                            );
                          })}

                    <TextNoResults>
                      {activeFilter
                        ? !loadingNext &&
                          employeesActiveList.length === 0 &&
                          'Nenhum usuário encontrado'
                        : !loadingNext &&
                          employeesInactiveList.length === 0 &&
                          'Nenhum usuário encontrado'}
                    </TextNoResults>
                    {( search ? false : (activeFilter ? hasMorePage : hasMorePageInactive) ) && (
                      <NextPageContainer content="center">
                        <NextPage onClick={() => nextPage(activeFilter)}>
                          {loadingNext ? (
                            <i
                              className="fa fa-spinner fa-pulse fa-3x fa-fw"
                              style={{
                                fontSize: '16px',
                                color: '#000FFF',
                              }}
                            />
                          ) : (
                            'Carregar mais...'
                          )}
                        </NextPage>
                      </NextPageContainer>
                    )}
                  </EmployeeListContainer>
                </>
              )}
            </Wrapper>
          </Content>
          <OpenChatBot />
        </SideBar>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
